import { FormEventHandler, useState } from 'react'
import Input from '../components/Input'
import { useQuery } from '../utils/useQuery'
import { Button } from '@bm-js/atlascloud-ui'
import { fetcher } from '../utils/fetcher'
import { Title } from 'react-head'
import { ChangeEvent } from '@bm-js/atlascloud-shared'

const CustomerUserRequestPasswordReset = () => {
  const queryEmail = useQuery().get('email')
  const websiteId = useQuery().get('websiteId')

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | false>(false)
  const [success, setSuccess] = useState(false)
  const [email, setEmail] = useState(queryEmail)

  const boxStyles = `w-full min-w-[unset] md:w-[unset] md:min-w-[400px] rounded-md bg-white p-4 shadow-xl`

  const handleSubmit: FormEventHandler = async (e) => {
    e.preventDefault()
    setError(false)
    setLoading(true)

    const { err } = await fetcher({
      path: 'customer-users-for-users/request-password-reset',
      body: { email, websiteId },
      method: 'POST',
    })

    if (err) setError('Återställningen misslyckades. Försök igen om en stund.')
    else setSuccess(true)

    setLoading(false)
  }

  const handleChange = (e: ChangeEvent) => {
    setError(false)
    setEmail(e.target.value)
  }
  return (
    <>
      <Title>Återställ lösenord | Atlascloud</Title>
      <div className='flex h-screen w-screen items-center justify-center bg-primary-400/40 p-4'>
        {success ? (
          <div className={boxStyles}>
            <p className='text-center text-2xl font-bold text-primary-400'>
              Klart!
            </p>
            <p className='mx-auto mt-2 max-w-[300px] text-center'>
              Om ett konto finns kopplat till mailadressen så har ett mail
              skickats med vidare instruktioner för att återställa ditt
              lösenord. Du kan stänga den här fliken.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className={boxStyles}>
            <p className='mb-2 text-2xl font-bold text-primary-400'>
              Återställ lösenord
            </p>
            <Input
              label='Mailadress'
              desc='Mailadressen du använder för att logga in på hemsidan'
              type={'email'}
              required
              disabled={loading}
              value={email}
              onChange={handleChange}
            />
            <Button type='submit' disabled={loading} className='w-full'>
              Återställ lösenord
            </Button>
            {error && (
              <p className='mx-auto mt-2 max-w-[300px] text-center font-bold text-red-500'>
                {error}
              </p>
            )}
          </form>
        )}
      </div>
    </>
  )
}

export default CustomerUserRequestPasswordReset
